export const whatsApp = {
    'UsageReport':'919246649070-1615282910@g.us',
    'attendanceReport' : '917382052052-1547014792@g.us',
    'VERSION': 'v17.0',
    'PHONE_NUMBER_ID': '168595539660514',
    'ACCESS_TOKEN': 'EAABtPfqQEJ0BO6obSjOyxHge99JAApPEZCLBGx5eMuiRYaMH1zeYJVZAFNTF034eD4Sn2HH9ymIWNqVkWtVXJyPSxKXvffaZCC5XVLpkx2fWCeDMT8bRP9chiFsMydZAh2ogvSc7WPlAHtCJlgFRBvl1UFtPqt2RAnTGy6NA9VLzsxD0h2ZAjoTZBVWKsb5K7bu72es4w1ZCZAa9ZAYZCR',
    'contacts':['918106067558'],
    'server':'LIVE DATA'
}
export default whatsApp;
